"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ValidationFormat = require("./ValidationFormat");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var AnswerValidator = /*#__PURE__*/_createClass(function AnswerValidator() {
  _classCallCheck(this, AnswerValidator);
});
_defineProperty(AnswerValidator, "isAnswerValid", function (question, answer) {
  if (!question) {
    return false;
  }
  if (question.required && (!answer || answer === "")) {
    return false;
  }
  if (question.validationFormat === _ValidationFormat.ValidationFormat.Email && answer && answer !== "") {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(answer);
  }
  if (question.validationFormat === _ValidationFormat.ValidationFormat.PhoneNumber && answer && answer !== "") {
    var _re = /^[+]?(1\-|1\s|1|\d{3}\-|\d{3}\s|)?((\(\d{3}\))|\d{3})(\-|\s)?(\d{3})(\-|\s)?(\d{4})$/g;
    return _re.test(answer);
  }
  if (question.validationFormat === _ValidationFormat.ValidationFormat.ZipCode && answer && answer !== "") {
    var _re2 = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
    return _re2.test(answer);
  }
  if ((question.validationFormat === _ValidationFormat.ValidationFormat.Currency || question.validationFormat === _ValidationFormat.ValidationFormat.Number) && answer && answer !== "") {
    if (typeof answer === "number") {
      return true;
    }
    var reg = /^\d+$/;
    return reg.test(answer);
  }
  return true;
});
var _default = AnswerValidator;
exports.default = _default;